import type { StatusId, ChangeTypeId } from '@app/app';

/**
 * Available status IDs for filtering
 */
export const STATUS_IDS: StatusId[] = [
  'COMING_SOON',
  'PLANNED',
  'ROLLING_OUT',
  'GENERALLY_AVAILABLE',
  'ROLLED_BACK',
];

/**
 * Available change type IDs for filtering
 */
export const CHANGE_TYPE_IDS: ChangeTypeId[] = [
  'IMPROVEMENT',
  'FIX',
  'EXPERIMENT',
  'REMOVED',
  'ANNOUNCEMENT',
];
